var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -705.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Shopping",
    transform: "translate(2352.000000, 705.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4777667,10.1874334 L29.9789801,26.2173897 C30.2454854,29.0548674 27.943758,31.5 25.008207,31.5 L25.008207,31.5 L7.99079502,31.5 C5.05624219,31.5 2.7545147,29.0548674 3.02102001,26.2173897 L3.02102001,26.2173897 L4.52223343,10.1874334 L28.4777667,10.1874334 Z M22.4888834,12.1249395 C21.936908,12.1249395 21.4907362,12.5589408 21.4907362,13.0936925 C21.4907362,13.6284442 21.936908,14.0624455 22.4888834,14.0624455 C23.0408588,14.0624455 23.4870306,13.6284442 23.4870306,13.0936925 C23.4870306,12.5589408 23.0408588,12.1249395 22.4888834,12.1249395 Z M10.5111168,12.1249395 C9.96013949,12.1249395 9.51296953,12.5589408 9.51296953,13.0936925 C9.51296953,13.6284442 9.96013949,14.0624455 10.5111168,14.0624455 C11.062094,14.0624455 11.509264,13.6284442 11.509264,13.0936925 C11.509264,12.5589408 11.062094,12.1249395 10.5111168,12.1249395 Z M16.5001997,0.5 C17.9525039,0.5 19.2490971,1.27015866 19.9677631,2.55956894 L19.9677631,2.55956894 L23.1388769,8.25002422 L20.8690901,8.25002422 L18.2120222,3.48085307 C17.8237429,2.78528839 17.1619713,2.43750605 16.5001997,2.43750605 C15.8384281,2.43750605 15.1756583,2.78528839 14.7883772,3.48085307 L14.7883772,3.48085307 L12.1303112,8.25002422 L9.86052439,8.25002422 L13.0326363,2.55956894 C13.7503041,1.27015866 15.0468974,0.5 16.5001997,0.5 Z",
    id: 217
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleShopping);
export default __webpack_public_path__ + "static/media/life-and-people-shopping.dd43f10d.svg";
export { ForwardRef as ReactComponent };